<a class="card card--property"
   target="_blank"
   *ngIf="homePreview.availableRooms != null"
   [routerLink]="['/find-a-home', homePreview.majorArea.reference, 'home', homePreview.propertyPublicReference, homePreview.availableRooms[0].reference]"
   >
    <div class="card__image">
        <div class="image__size image__size--4x3">
            <img [lazyLoad]="homePreview.image.thumbnail" [offset]="400" alt="{{homePreview.headlineDescription}} image" defaultImage="https://d19qeljo1i8r7y.cloudfront.net/images/placeholder/room.png">
        </div>
        <div class="card__image-caption">{{homePreview.availableRooms[0].name}}</div>
    </div>
    <div class="card__users">
        <ul class="user__group">
            <li *ngFor="let housemate of homePreview.housemates">
                <div class="profile__mini-image">
                    <img [lazyLoad]="housemate.image.thumbnail" [offset]="400" alt="Housemate" defaultImage="https://d19qeljo1i8r7y.cloudfront.net/images/placeholder/user-other.png" />
                </div>
            </li>
            <li class="user__group-more" *ngIf="homePreview.additionalHousemates > 0">
                <ng-container *ngIf="homePreview.housemates.length > 0">+</ng-container>{{homePreview.additionalHousemates}} <ng-container *ngIf="homePreview.housemates == null || homePreview.housemates.length == 0"> housemates</ng-container>
            </li>
        </ul>
    </div>



    <div class="card__content">

        <ul class="profile__preview-interests" *ngIf="homePreview.interests != null && homePreview.interests.length > 0">
            <li *ngFor="let interest of homePreview.interests | slice:0:4">
                <img lazyLoad="assets/images/icons/interests/icon-{{interest.reference}}--large.png" alt="{{interest.name}}">
                <div class="tooltip">
                    {{interest.name}}
                </div>
            </li>
        </ul>

        <p class=" u-text-color--grey u-margin-bottom--none"><ng-container *ngIf="homePreview.minorArea != null">{{homePreview.minorArea.label}}</ng-container><ng-container *ngIf="showAddress"><ng-container *ngIf="homePreview.minorArea != null">,</ng-container> {{homePreview.majorArea.label}}</ng-container></p>
        <h5 class="heading--4 u-margin-top--none">{{homePreview.headlineDescription}}</h5>
        <div class="text__price">
            <p>from</p>
            <p>
                <strong>{{homePreview.availableRooms[0].rentDetails.rent | houseShareCurrency}}</strong> / <ng-container *ngIf="homePreview.availableRooms[0].rentDetails.paymentFrequency == RentPaymentFrequencies.MONTH">month</ng-container><ng-container *ngIf="homePreview.availableRooms[0].rentDetails.paymentFrequency == RentPaymentFrequencies.WEEK">week</ng-container><ng-container *ngIf="homePreview.availableRooms[0].rentDetails.paymentFrequency == RentPaymentFrequencies.FORTNIGHT">fortnight</ng-container><ng-container *ngIf="homePreview.availableRooms[0].rentDetails.paymentFrequency == RentPaymentFrequencies.TERM">term</ng-container><ng-container *ngIf="homePreview.availableRooms[0].rentDetails.paymentFrequency == RentPaymentFrequencies.QUARTER">quarter</ng-container><ng-container *ngIf="homePreview.availableRooms[0].rentDetails.paymentFrequency == RentPaymentFrequencies.ANNUAL">year</ng-container>
                <ng-container *ngIf="homePreview.availableRooms[0].rentDetails.billsInclusive == BillsInclusiveTypes.INCLUDED"> inc bills</ng-container>
            </p>
        </div>
    </div>
</a>


